/**
 * Routes that render a height-locked columned surface (Miller columns / org
 * tree) rather than a normally-scrolling page.
 *
 * These pages must NOT scroll as a page — each column scrolls internally, so
 * the header row stays put while a long list moves. That only works if the
 * height constraint runs unbroken from the viewport down to each column's
 * scroller: one ancestor sized to its content and every descendant inherits the
 * inflated height, the internal scrollers never engage, and the overflow is
 * silently clipped — a page with no scrollbar at all.
 *
 * Lives here rather than in `MainLayout` because two places need the same list
 * (the layout, to lock `<main>`; `AdminPage`, to keep its own wrapper in the
 * flex chain). Two copies of a route list is how they drift apart.
 */
export const SPLIT_PANE_ROUTES: readonly string[] = [
  "/admin/organizations",
  "/admin/impersonation",
  "/admin/users",
  "/admin/groups",
  // `/credentials` was here while it rendered Miller columns. It is an ordinary
  // scrolling page again, and being on this list did real damage: the split-pane
  // branch in `MainLayout` sets no max-width at all, so the page ignored the
  // account's "Main content width" preference outright -- picking "Centered"
  // in Settings changed nothing on it -- and `overflow-hidden` meant the page
  // could not scroll, only its columns could.
];

/** True when `pathname` is a height-locked columned surface. Exact match: the
 *  nested analytics routes under these paths are ordinary scrolling pages. */
export function isSplitPaneRoute(pathname: string): boolean {
  return SPLIT_PANE_ROUTES.includes(pathname);
}
